import { render, staticRenderFns } from "./LinkedinCompany.vue?vue&type=template&id=ec8742e2&scoped=true"
import script from "./LinkedinCompany.vue?vue&type=script&lang=js"
export * from "./LinkedinCompany.vue?vue&type=script&lang=js"
import style0 from "./LinkedinCompany.vue?vue&type=style&index=0&id=ec8742e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8742e2",
  null
  
)

export default component.exports